<template>
  <div class="soar-container">
    <CollapsibleSection :header-label="$t('fileValidity')" body-class="flex flex-col gap-y-5">
      <Form
        v-if="!isLoading"
        :initial-values="initialValues"
        :keep-values="true"
        class="flex flex-col gap-y-5"
        v-slot="{ errors, values, resetField, setFieldValue }"
        @submit="(values) => submitRequest(values)"
      >
        <fieldset class="border-2 border-primary rounded p-4 flex flex-col gap-y-5">
          <Field name="byEstabCardNumber" v-slot="{ field, errors: errs, handleChange }">
            <RadioGroup
              :field="field"
              :errors="errs"
              :label="$t('searchBy')"
              :radio-options="[
                {
                  label: $t('establishmentCardNumber'),
                  value: true
                },
                {
                  label: $t('licenceInfo'),
                  value: false
                }
              ]"
              :default-value="field.value"
              class="px-1.5 w-full md:w-1/2"
              @on-change="
                (item) => {
                  handleChange(item.value)
                }
              "
            ></RadioGroup>
          </Field>
          <component
            :is="values.byEstabCardNumber ? EstCardnumberForm : LicenseForm"
            :fields="values"
            :departments
            :resetField
          ></component>
        </fieldset>

        <fieldset class="border-2 border-primary rounded p-4 flex flex-col items-center gap-y-5">
          <legend class="px-4 text-lg">{{ $t('verifyApplicant') }}</legend>
          <GRecaptcha
            ref="gRecaptchaRef"
            @successCallback="(args) => setFieldValue('recaptchaResponse', args)"
          ></GRecaptcha>
        </fieldset>
        <div class="pt-4 w-full flex justify-end gap-x-4 border-t border-brand-gray-300">
          <button
            class="text-center rounded-md bg-primary/80 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
          >
            <div class="p-2 bg-primary rounded-s-md">
              <faMagnifyingGlass class="w-4 fill-white"></faMagnifyingGlass>
            </div>
            <span class="w-full text-center">
              {{ $t('Search') }}
            </span>
            <div class="p-0.5"></div>
          </button>
        </div>
      </Form>
      <ResultView v-if="result" :est-info="result" />
    </CollapsibleSection>
  </div>
</template>

<script setup>
import faMagnifyingGlass from '@/assets/icons/faMagnifyingGlass.svg?component'
import GRecaptcha from '@/components/GRecaptcha/index.vue'
import RadioGroup from '@/components/SimpleForm/RadioGroup.vue'
import CollapsibleSection from '@/components/Ui/CollapsibleSection.vue'
import axiosInstance from '@/services'
import { useLookupsStore } from '@/stores/lookups'
import EstCardnumberForm from '@/views/establishment-inquiry/_EstCardnumberForm.vue'
import LicenseForm from '@/views/establishment-inquiry/_LicenseForm.vue'
import { Field, Form } from 'vee-validate'
import { onMounted, ref } from 'vue'
import ResultView from '@/views/establishment-inquiry/_ResultView.vue'

const lookupsStore = useLookupsStore()

const initialValues = {
  byEstabCardNumber: true,
  estabDepartmentId: 17,
  establishmentNumber: 29586,
  establishmentSponsorType: 5
}

const departments = ref()
const isLoading = ref(true)
const result = ref()

onMounted(async () => {
  await fetchLookups()
})

async function fetchLookups() {
  departments.value = await lookupsStore.fetchLookup('/api/lookup/departments')

  isLoading.value = false
}

async function submitRequest(form) {
  const { establishmentNumber, establishmentSponsorType } = form
  const body = {
    ...form,
    isUsingCaptcha: true,
    establishmentCardNumber: `${establishmentNumber}/${establishmentSponsorType}`
  }

  result.value = await axiosInstance.post('/api/landing/establishmentInquiry', body)
}
</script>

<style lang="scss" scoped></style>
